import { render, staticRenderFns } from "./StockoutsTitle.vue?vue&type=template&id=6bd3d255&scoped=true"
import script from "./StockoutsTitle.vue?vue&type=script&lang=js"
export * from "./StockoutsTitle.vue?vue&type=script&lang=js"
import style0 from "./StockoutsTitle.vue?vue&type=style&index=0&id=6bd3d255&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd3d255",
  null
  
)

export default component.exports